import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DialogConfirmacaoComponent } from '@components/dialog-confirmacao/dialog-confirmacao.component';

import { RegraConciliacaoAutomaticaApiService } from '../../../services/regra-conciliacao-automatica-api.service';
import { RegraConciliacaoAutomatica } from '../../../models/regra-conciliacao-automatica';
import { TipoLancamentoOpcao } from '../../../models/tipo-lancamento-opcao';
import { OpcaoTipoVerificacao, OPCOES_TIPO_VERIFICACAO, TipoVerificacaoEnum } from '../../../models/tipo-verificacao.enum';
import { MessageService } from '@services/message.service';

@Component({
  selector: 'app-regra-conciliacao-automatica-dialog',
  standalone: false,
  templateUrl: './regra-conciliacao-automatica-dialog.component.html',
  styleUrl: './regra-conciliacao-automatica-dialog.component.scss'
})
export class RegraConciliacaoAutomaticaDialogComponent implements OnInit {

  contaCaixaId: number;
  regra: RegraConciliacaoAutomatica | null;
  tiposOrigem: TipoLancamentoOpcao[];
  tiposDestino: TipoLancamentoOpcao[];
  termoBuscaInicial: string | null = null;

  title: string;
  opcoesTipoVerificacao: OpcaoTipoVerificacao[] = OPCOES_TIPO_VERIFICACAO;

  regraForm: RegraConciliacaoAutomatica;
  opcaoTipoVerificacaoSelecionada: OpcaoTipoVerificacao | null = null;
  tipoOrigemSelecionado: TipoLancamentoOpcao | null = null;
  tipoDestinoSelecionado: TipoLancamentoOpcao | null = null;

  salvando = false;

  constructor(
    private regraConciliacaoAutomaticaApiService: RegraConciliacaoAutomaticaApiService,
    private messageService: MessageService,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<RegraConciliacaoAutomaticaDialogComponent>,
  ) { }

  ngOnInit(): void {
    this.title = this.regra ? 'Editar regra' : 'Nova regra';

    this.regraForm = this.regra ? { ...this.regra } : this.novaRegraVazia();
    if (!this.regra && this.termoBuscaInicial) this.regraForm.termoBusca = this.termoBuscaInicial;
    this.opcaoTipoVerificacaoSelecionada = this.opcoesTipoVerificacao.find(o => o.value === this.regraForm.tipoVerificacao) ?? null;
    this.tipoOrigemSelecionado = this.tiposOrigem.find(t => t.id === this.regraForm.tipoLancamentoOrigemId) ?? null;
    this.tipoDestinoSelecionado = this.tiposDestino.find(t => t.id === this.regraForm.tipoLancamentoDestinoId) ?? null;
  }

  public salvarClick(): void {
    const erro = this.validar();
    if (erro) { this.messageService.showToastWarning(erro); return; }

    const input: RegraConciliacaoAutomatica = {
      ...this.regraForm,
      contaCaixaId: this.contaCaixaId,
      tipoVerificacao: this.opcaoTipoVerificacaoSelecionada!.value,
      tipoLancamentoOrigemId: this.tipoOrigemSelecionado!.id,
      tipoLancamentoOrigemNome: this.tipoOrigemSelecionado!.nome,
      tipoLancamentoDestinoId: this.tipoDestinoSelecionado!.id,
      tipoLancamentoDestinoNome: this.tipoDestinoSelecionado!.nome,
    };

    this.salvando = true;

    if (input.id === 0) {
      this.regraConciliacaoAutomaticaApiService.criar(input).subscribe({
        next: (resultado) => {
          this.messageService.showToastSuccess('Regra criada com sucesso');
          this.dialogRef.close({ ...input, id: resultado.id });
          if (resultado.aviso) this.abrirAvisoConflito(resultado.aviso);
        },
        error: () => { this.salvando = false; }
      });
    } else {
      this.regraConciliacaoAutomaticaApiService.editar(input.id, input).subscribe({
        next: (resultado) => {
          this.messageService.showToastSuccess('Regra salva com sucesso');
          this.dialogRef.close(input);
          if (resultado.aviso) this.abrirAvisoConflito(resultado.aviso);
        },
        error: () => { this.salvando = false; }
      });
    }
  }

  private abrirAvisoConflito(aviso: string): void {
    const dialogRef = this.dialog.open(DialogConfirmacaoComponent, {
      width: '450px',
      panelClass: 'no-padding-dialog',
      disableClose: true,
    });
    dialogRef.componentInstance.titulo = 'Atenção';
    dialogRef.componentInstance.mensagem = aviso;
    dialogRef.componentInstance.mostrarBtnConfirmar = false;
    dialogRef.componentInstance.textoBtnCancelar = 'Ok';
  }

  private validar(): string | null {
    if (!this.regraForm.termoBusca?.trim()) return 'Informe o termo de busca';
    if (!this.opcaoTipoVerificacaoSelecionada) return 'Selecione o tipo de verificação';
    if (!this.tipoOrigemSelecionado) return 'Selecione o tipo de lançamento de origem';
    if (!this.tipoDestinoSelecionado) return 'Selecione o tipo de lançamento de destino';
    if (!this.regraForm.loteLancamento?.trim()) return 'Informe o nome do lote de lançamento';
    return null;
  }

  private novaRegraVazia(): RegraConciliacaoAutomatica {
    return {
      id: 0,
      contaCaixaId: this.contaCaixaId,
      termoBusca: '',
      tipoVerificacao: TipoVerificacaoEnum.Igual,
      tipoLancamentoOrigemId: 0,
      tipoLancamentoOrigemNome: '',
      observacaoOrigem: null,
      tipoLancamentoDestinoId: 0,
      tipoLancamentoDestinoNome: '',
      observacaoDestino: null,
      loteLancamento: '',
      observacao: null,
    };
  }
}
